import React from "react";
import "../../ShoeCare/FromSneakers/SuitableFor.css";

const items = [
  {
    title: "Belt",
    img: "/Professional  Beg/Belt-1.webp",
    desc: "ê 0 + VAT",
  },

  {
    title: "Clutch",
    img: "/Professional  Beg/bag2-1.webp",
    desc: "20 + VAT",
  },
  {
    title: "Sling Bag",
    img: "/Professional  Beg/bag1-1.webp",
    desc: "80 + VAT",
  },
  {
    title: "Standard Size Handbag",
    img: "/Professional  Beg/bag3_copy-removebg-preview.webp",
    desc: " 90 + VAT",
  },

  {
    title: "Designer Standard Size",
    img: "/Professional  Beg/bag4-1.webp",
    desc: " 40 + VAT",
  },
  {
    title: "Designer Oversized Handbag",
    img: "/Professional  Beg/bag5-1.webp",
    desc: "120 + VAT",
  },
  {
    title: "Backpack",
    img: "/Professional  Beg/bag6-1.webp",
    desc: "30 + VAT",
  },
  {
    title: "Backpack (Branded)",
    img: "/Professional  Beg/bag6-1.webp",
    desc: "60 + VAT",
  },
  {
    title: "Luggage Bag (Hand Case) Branded",
    img: "/Professional  Beg/bag10-1.webp",
    desc: "50 + VAT",
  },
];

export default function EverydayTotes() {
  const DirhamIcon = () => (
    <svg width="14" height="14" viewBox="0 0 100 100">
      <path
        d="M20 10 L20 90 Q80 90 80 50 Q80 10 20 10"
        stroke="#5a0b64"
        strokeWidth="10"
        fill="none"
      />
      <line
        x1="20"
        y1="40"
        x2="100"
        y2="40"
        stroke="#5a0b64"
        strokeWidth="10"
      />
      <line
        x1="20"
        y1="60"
        x2="100"
        y2="60"
        stroke="#5a0b64"
        strokeWidth="10"
      />
    </svg>
  );
  return (
    <section className="fromsneakers-section">
      <h2 className="text-center" style={{ color: "rgb(75, 46, 131)" }}>
        From Everyday Totes to Designer Pieces – We Restore Them All
      </h2>
      <span style={{ fontSize: "15px" }}>
        Our professional bag restoration services revive designer handbags,
        leather totes, backpacks, and everyday bags with expert <br />
        cleaning, stain removal, and repair. Trust us to restore your bags to
        pristine condition, no matter the brand or material.
      </span>
      <div className="fromsneakers-grid mt-3">
        {items.map((item, i) => (
          <div className="fromsneakers-card" key={i}>
            <div className="fromsneakers-box">
              <img src={item.img} alt={item.title} />
            </div>
            <h3>{item.title}</h3>
            <p>
              {item.desc} <DirhamIcon />
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
